// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__YAHo3","colMaxWidth":"Table_colMaxWidth__11HwQ"};